var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ClickEventListener } from '@philips-internal/oswald-ui-core/lib/component/types';
class CardExamsTitleAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        this.onSubmitCheck = new ClickEventListener();
    }
    setEnabled(check) {
        this.setState({ check });
    }
    getCheckState() {
        return this.state.check;
    }
}
__decorate([
    AwesomeEvent
], CardExamsTitleAPI.prototype, "onSubmitCheck", void 0);
export default CardExamsTitleAPI;
//# sourceMappingURL=cad-exams-title-api.js.map